import { useState } from "react";
import { Send, CheckCircle2 } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import api from "../lib/api";
import { toast } from "sonner";

export default function SopralluogoForm() {
  const [f, setF] = useState({ name: "", business: "", phone: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (f.name.trim().length < 2 || f.business.trim().length < 2 || f.phone.trim().length < 6) { toast.error("Compila nome, locale e telefono"); return; }
    setBusy(true);
    try {
      await api.post("/contact", { name: f.name.trim(), business: f.business.trim(), phone: f.phone.trim(), kind: "sopralluogo",
        message: `Richiesta sopralluogo per impianto in comodato. Locale: ${f.business.trim()}. Telefono: ${f.phone.trim()}.` });
      setDone(true);
    } catch (err) { toast.error(err?.response?.data?.detail || "Invio non riuscito, riprova"); } finally { setBusy(false); }
  };
  return (
    <div className="mt-20 rounded-3xl bg-[#0B2A45] text-white p-8 sm:p-12" data-testid="sopralluogo-form">
      <div className="grid lg:grid-cols-2 gap-8 items-center">
        <div>
          <div className="eyebrow text-[#FDE047] mb-3">Sopralluogo gratuito</div>
          <h2 className="font-serif font-semibold text-3xl lg:text-4xl leading-tight">Vuoi un impianto nel tuo locale?</h2>
          <p className="mt-4 text-stone-200 leading-relaxed">Lasciaci nome, locale e telefono: ti richiamiamo entro un giorno lavorativo per fissare un sopralluogo, senza registrazione.</p>
        </div>
        {done ? (
          <div className="bg-white/10 border border-white/20 rounded-2xl p-8 text-center" data-testid="sopralluogo-success">
            <CheckCircle2 className="w-12 h-12 text-[#FDE047] mx-auto mb-3" />
            <p className="font-serif text-xl font-semibold">Richiesta inviata!</p>
            <p className="text-sm text-stone-200 mt-1">Ti richiamiamo al numero indicato per concordare il sopralluogo.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-white rounded-2xl p-6 sm:p-8 space-y-4 text-[#0B2A45]">
            <Input value={f.name} onChange={set("name")} placeholder="Nome e cognome" className="h-12 rounded-xl" data-testid="sopralluogo-name" required />
            <Input value={f.business} onChange={set("business")} placeholder="Nome del locale (bar, lido, ristorante…)" className="h-12 rounded-xl" data-testid="sopralluogo-business" required />
            <Input value={f.phone} onChange={set("phone")} type="tel" placeholder="Telefono" className="h-12 rounded-xl" data-testid="sopralluogo-phone" required />
            <Button type="submit" disabled={busy} className="w-full h-12 rounded-full bg-[#C2593F] hover:bg-[#9A3412] text-white" data-testid="sopralluogo-submit"><Send className="w-4 h-4 mr-2" />{busy ? "Invio…" : "Richiedi il sopralluogo"}</Button>
            <p className="text-xs text-stone-400 text-center">Nessuna registrazione richiesta. I dati servono solo per ricontattarti.</p>
          </form>
        )}
      </div>
    </div>
  );
}
